import type { BlogPost } from "@/pages/blog/blogData";

export default function ArticleContent({ post }: { post: BlogPost }) {
  const toc = post.content.filter((block) => block.level === 2);

  return (
    <div>
      <div className="space-y-5">
        {post.intro.map((paragraph) => (
          <p key={paragraph.slice(0, 24)} className="text-base leading-relaxed text-foreground-700">
            {paragraph}
          </p>
        ))}
      </div>

      {toc.length > 0 ? (
        <nav
          aria-label="Índice do conteúdo"
          className="mt-8 rounded-xl border border-background-200 bg-background-100/70 p-5 md:p-6"
        >
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-foreground-500">
            <i className="ri-list-check-2 text-base text-primary-600" aria-hidden="true"></i>
            Índice do conteúdo
          </p>
          <ol className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
            {toc.map((block, index) => (
              <li key={block.id}>
                <a
                  href={`#${block.id}`}
                  className="flex items-start gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                >
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[11px] font-semibold text-primary-700">
                    {index + 1}
                  </span>
                  {block.heading}
                </a>
              </li>
            ))}
          </ol>
        </nav>
      ) : null}

      <div className="mt-10 space-y-10">
        {post.content.map((block) => (
          <section key={block.id} id={block.id} className="scroll-mt-28">
            {block.level === 2 ? (
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {block.heading}
              </h2>
            ) : (
              <h3 className="font-heading text-lg font-semibold text-foreground-900">{block.heading}</h3>
            )}

            {block.paragraphs?.length ? (
              <div className="mt-4 space-y-4">
                {block.paragraphs.map((paragraph) => (
                  <p key={paragraph.slice(0, 24)} className="text-base leading-relaxed text-foreground-700">
                    {paragraph}
                  </p>
                ))}
              </div>
            ) : null}

            {block.list?.length ? (
              <ul className="mt-4 space-y-2.5">
                {block.list.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                    <i className="ri-checkbox-circle-line mt-0.5 text-lg text-secondary-500" aria-hidden="true"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
}